<template>
  <div class="cart-table">
    <div class="cart-head">
      <div>
        <p>Image</p>
      </div>

      <div>
        <p>Product</p>
      </div>

      <div>
        <p>Price</p>
      </div>
    </div>

    <a v-for="(product, index) in cartStore.products" class="cart-row" :href="product.href">
      <div>
        <div class="img-wrapper">
          <img :src="product.image.thumb" :alt="product.title">
        </div>
      </div>

      <div>
        <p class="large ff-serif">{{ product.title }}</p>

        <div class="d-flex mt-3">
          <!-- <div v-if="product.variant_attrs.length > 0"></div> -->

          <p class="xxxsmall fw-light"><strong>code:</strong> {{ product.code }}</p>
        </div>
      </div>

      <div>
        <p v-if="product.initPrice > 0 && product.unit_price < product.initPrice" class="init-price"><span>{{ $c(product.initPrice) }}</span></p>
        <p><span>{{ $c(product.unit_price) }}</span></p>
      </div>
    </a>
  </div>

  <div class="cart-total mt-15">
    <div class="d-flex align-items-center justify-content-between">
      <p class="large fw-light me-3">Total:</p>
      <p class="h2 fw-light">{{ $c(cartStore.total.total) }}</p>
    </div>

    <a :href="$root.shopUrls.checkout" class="btn-outline btn-secondary">Checkout</a>
  </div>
</template>

<script setup>
import { useCartStore } from './store.js';
const cartStore = useCartStore();

cartStore.get();

</script>

<style lang="scss"></style>